module.exports = __webpack_public_path__ + "static/img/instagram.ed4c23b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram.png
// module id = 1447
// module chunks = 4